import React, { useState, useMemo, useEffect } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { GlobalStyles } from "@mui/material";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";

const getDesignTokens = (mode) => ({
  palette: {
    mode,
    primary: {
      main: mode === "dark" ? "#004998" : "#147ccb",
    },
    secondary: {
      main: mode === "dark" ? "#c7c7c7" : "#6f6f6f",
    },
    bg_light: {
      main: mode === "dark" ? "#fff" : "#111",
    },
    theme_text: {
      main: mode === "dark" ? "#111" : "#fff",
    },
  },
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#0061bd",
            color: "#fff",
          },
          "&.Mui-selected:hover": {
            backgroundColor: "#004a99",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "#004a99",
          },
          "&:hover": {
            backgroundColor: "#e3f2fd",
            color: "#111111",
          },
          "&:focus": {
            backgroundColor: "#004a99",
            color: "#ffffff",
          },
        },
      },
    },
  },
});

const ToggleThemeButton = styled("button")(({ theme }) => ({
  position: "fixed",
  bottom: "10px",
  right: "10px",
  zIndex: theme.zIndex.drawer + 2,
  padding: "4px 8px",
  backgroundColor: theme.palette.bg_light.main,
  color: theme.palette.theme_text.main,
  borderRadius: "5px",
  transition: "0.3s",
  cursor: "pointer",
  border: "none",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  boxShadow: theme.shadows[2],
}));

const ThemeProviderWrapper = ({ children }) => {
  const [mode, setMode] = useState(
    () => localStorage.getItem("theme") || "dark"
  );

  useEffect(() => {
    localStorage.setItem("theme", mode);
  }, [mode]);

  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  const handleThemeToggle = () => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
    
      <GlobalStyles
        styles={{          
          "*": {
            scrollbarColor:
              theme.palette.mode === "dark"
                ? "#454545 #242424"
                : "#c1c1c1 #f0f0f0",
          },
        }}
      />
      <ToggleThemeButton onClick={handleThemeToggle}>
        <Grid container alignItems="center" spacing={1} wrap="nowrap">
          <Grid item>
            {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
          </Grid>
          <Grid item>{mode === "dark" ? "Light" : "Dark"}</Grid>
        </Grid>
      </ToggleThemeButton>
      {children}
    </ThemeProvider>
  );
};

export default ThemeProviderWrapper;
